/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { CategorizedSettingsObject } from 'jotai/filterSearch';
import { LocalVehicleSelectionsObject } from 'jotai/visualizationSettings';
import { AlertType } from 'models/viewModels';

export enum AlertColorType {
  CUSTOM = 'custom',
  GLOBAL = 'global',
  FLAGS = 'flags',
}

export interface AlertVehicleSelections extends LocalVehicleSelectionsObject {
  allVehicles: boolean;
}

export interface AlertNotificationLogSettingsObject extends CategorizedSettingsObject {
  id: string;
  // AlertType to which color type is applied
  alertColorSelections: Record<AlertType, AlertColorType>;
  // AlertType to custom color id from the color picker
  customAlertColors: Record<AlertType, string>;
  // AlertType to vehicle selection
  alertVehicleSelections: Record<AlertType, AlertVehicleSelections>;
  textFilter: string; // stored as string to allow populating search input value, converted to list by selector
  // audio keywords for audio alerts. Stored as string to allow populating search input value, converted to list by selector
  audioKeywords: string;
  enableNotifications: boolean;
}
